import React, { useContext } from 'react'
import { Grid } from '@mui/material'
import clsx from 'clsx'

import { GridContext } from './GridContext'
import { MuiGridProps } from './GridContainer'
import { RowStyleProps, useRowStyles } from './GridStyles'

// when adding Props, dont forget to extract them
// so that rest props can safely be passed to <Grid>
type Props = MuiGridProps & RowStyleProps & {
  className?: string
}

const Row: React.FC<Props> = (props) => {
  const { spacingTop, spacingBottom, spacingHorizontal, className, ...rest } = props
  const { gridSpacing, defaultRowSpacingHorizontal } = useContext(GridContext)
  const s = useRowStyles({
    spacingTop,
    spacingBottom,
    spacingHorizontal: spacingHorizontal !== undefined
      ? spacingHorizontal
      : (
        defaultRowSpacingHorizontal !== undefined ? defaultRowSpacingHorizontal : gridSpacing
      ),
  })

  return <Grid
    container
    spacing={gridSpacing}
    item xs={12}
    className={clsx(
      s.spacingTop,
      s.spacingHorizontal,
      (spacingBottom !== undefined) && s.spacingBottom,
      className,
    )}
    {...rest}
  >
    {props.children}
  </Grid>
}

export default Row
